// Recapiti approvati per i materiali MRF del 15 ottobre 2026.
// L'indirizzo istituzionale resta disponibile anche per le richieste privacy.
export const MRF_CONTACTS = [
  { label: 'Segreteria MRF', value: 'segreteriamrf@gmail.com', href: 'mailto:segreteriamrf@gmail.com' },
  { label: 'Telefono MRF', value: '011 6995258', href: 'tel:+390116995258' },
  { label: 'Cellulare MRF', value: '320 5533053', href: 'tel:+393205533053' },
  { label: 'Cellulare MRF', value: '392 7421142', href: 'tel:+393927421142' },
  { label: 'Contatti istituzionali e privacy', value: 'info@movimentorivoluzionefiscale.it', href: 'mailto:info@movimentorivoluzionefiscale.it' },
]
